<ion-grid class="ion-no-padding">

    <ion-row class="ion-no-padding" *ngIf="!studentComment" [ngClass]="{'white-bg': inReserved}">
        <ion-col class="ion-no-padding">
            <ion-grid class="wrapper" *transloco="let t; read: 'notificationComp'"
                      [ngClass]="{'height': inReserved, 'with-margin-bottom':withMarginBottom}">
                <ion-row class="ion-align-items-center">
                    <ion-col size="auto" class="title-wrapper margin-bottom">
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M16.7856 6.82952L14.1915 4.23286C12.4181 2.45779 11.5314 1.57025 10.5791 1.78035C9.6268 1.99045 9.19503 3.16886 8.33148 5.52568L7.74701 7.12084C7.5168 7.74915 7.40169 8.0633 7.19459 8.30631C7.10167 8.41534 6.99594 8.51276 6.87969 8.59644C6.62064 8.78295 6.29835 8.8718 5.65377 9.0495C4.20094 9.45003 3.47452 9.65029 3.20078 10.1256C3.08245 10.331 3.02087 10.5643 3.02237 10.8015C3.02583 11.3501 3.55861 11.8834 4.62416 12.95L5.86193 14.1892L1.94552 18.1094C1.68483 18.3703 1.68483 18.7934 1.94552 19.0543C2.20621 19.3153 2.62887 19.3153 2.88957 19.0543L6.80611 15.1341L8.08886 16.4181C9.16119 17.4915 9.69736 18.0281 10.2492 18.029C10.4818 18.0293 10.7104 17.9689 10.9124 17.8536C11.3918 17.58 11.5932 16.8482 11.9958 15.3847C12.1729 14.7413 12.2614 14.4195 12.4472 14.1606C12.5286 14.0472 12.623 13.9438 12.7284 13.8525C12.9693 13.6439 13.2814 13.5266 13.9057 13.2921L15.5192 12.6859C17.85 11.8102 19.0154 11.3723 19.2208 10.4225C19.4262 9.47275 18.546 8.59167 16.7856 6.82952Z"
                                fill="#3F403F"/>
                        </svg>

                        {{ t('title') }}

                    </ion-col>
                    <ion-col size="auto"></ion-col>

                </ion-row>
                <ion-row *ngIf="hasNotPaid">{{ t('hasNotPaid') }}</ion-row>
                <ion-row *ngIf="inReserved && !hasNotPaid">{{ t('inReserved', {name: this.childName}) }}</ion-row>
            </ion-grid>
        </ion-col>
<!--        <ion-col *ngIf="inReserved && !hasNotPaid" size="5" size-xl="5" size-lg="5" size-md="12" size-sm="12"-->
        <ion-col *ngIf="inReserved && !hasNotPaid " size="5" size-xl="5" size-lg="5" size-md="12" size-sm="12"
                 size-xs="12" class="social-wrapper">

            <div class="item">

                <a href="tel:{{CONTACT_PHONE}} ">
                    <img src="../../../../assets/images/icons/social/call_contact.svg"></a>

                {{ ('call')|transloco }}
            </div>

            <div class="item" *ngFor="let link of CONTACT_LINKS" (click)="openSocialLink(link.href)">

                <img src="../../../../assets/images/icons/social/{{link.icon}}">

                {{ link.title }}
            </div>


        </ion-col>

    </ion-row>

    <ion-row class="ion-no-padding" *ngIf="studentComment">
        <ion-col class="ion-no-padding">
            <ion-grid class="wrapper student-comment" *transloco="let t; read: 'notificationComp'" [ngClass]="{'with-margin-bottom':withMarginBottom}">
                <ion-row class="ion-align-items-center">
                    <ion-col size="auto" class="title-wrapper">
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M16.7856 6.82952L14.1915 4.23286C12.4181 2.45779 11.5314 1.57025 10.5791 1.78035C9.6268 1.99045 9.19503 3.16886 8.33148 5.52568L7.74701 7.12084C7.5168 7.74915 7.40169 8.0633 7.19459 8.30631C7.10167 8.41534 6.99594 8.51276 6.87969 8.59644C6.62064 8.78295 6.29835 8.8718 5.65377 9.0495C4.20094 9.45003 3.47452 9.65029 3.20078 10.1256C3.08245 10.331 3.02087 10.5643 3.02237 10.8015C3.02583 11.3501 3.55861 11.8834 4.62416 12.95L5.86193 14.1892L1.94552 18.1094C1.68483 18.3703 1.68483 18.7934 1.94552 19.0543C2.20621 19.3153 2.62887 19.3153 2.88957 19.0543L6.80611 15.1341L8.08886 16.4181C9.16119 17.4915 9.69736 18.0281 10.2492 18.029C10.4818 18.0293 10.7104 17.9689 10.9124 17.8536C11.3918 17.58 11.5932 16.8482 11.9958 15.3847C12.1729 14.7413 12.2614 14.4195 12.4472 14.1606C12.5286 14.0472 12.623 13.9438 12.7284 13.8525C12.9693 13.6439 13.2814 13.5266 13.9057 13.2921L15.5192 12.6859C17.85 11.8102 19.0154 11.3723 19.2208 10.4225C19.4262 9.47275 18.546 8.59167 16.7856 6.82952Z"
                                fill="#3F403F"/>
                        </svg>

                        {{ t('title') }}

                    </ion-col>
                    <ion-col size="auto"></ion-col>

                </ion-row>
                <ion-row>
                    <div [innerHTML]="studentComment">

                    </div>
                </ion-row>
            </ion-grid>
        </ion-col>

    </ion-row>


</ion-grid>
